import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, arrayMove} from "@dnd-kit/sortable";
import { useEffect, useState } from "react";
import SupportingMaterialService from "../../../../services/SupportingMaterialService";
import SortableItemRow from "./SortableItemRow ";

const ItemsSortableList = ({ subCat, openModalEditItem, deleteItem, toggleActiveItem, openForType, getNameTypeFile,openModalAddItem }: any) => {

    const [items, setItems] = useState(subCat.itemLinks || []);

    useEffect(() => {
        setItems(
            (subCat.itemLinks || [])
                .slice()
                .sort((a: any, b: any) => a.item.ordem - b.item.ordem)
        );
    }, [subCat]);

    return (
        <DndContext
            collisionDetection={closestCenter}
            onDragEnd={(event) => {
                const { active, over } = event;

                if (!over || active.id === over.id) return;

                const oldIndex = items.findIndex((i:any) => i.item.id === active.id);
                const newIndex = items.findIndex((i:any) => i.item.id === over.id);

                const newItems = arrayMove(items, oldIndex, newIndex);
                setItems(newItems);

                const payload = newItems.map((i:any, index:number) => ({
                    id: i.item.id,
                    ordem: index + 1
                }));

                SupportingMaterialService.updateItemOrdem(payload);
            }}
        >
            <button className="btn" style={{ padding:0, background:'transparent'}} onClick={() => {openModalAddItem(subCat.id);}}>
                <i className="mdi mdi-plus-circle" style={{fontSize: 24, color:'#007733'}} /> Adicionar item
            </button>
            <SortableContext
                items={items.map((i:any) => i.item.id)}
                strategy={verticalListSortingStrategy}
            >
                {items.map((item:any) => (
                    <SortableItemRow
                        key={item.item.id}
                        item={item}
                        openModalEditItem={openModalEditItem}
                        deleteItem={deleteItem}
                        toggleActiveItem={toggleActiveItem}
                        openForType={openForType}
                        getNameTypeFile={getNameTypeFile}
                        subCatId={subCat.id}
                    />
                ))}
            </SortableContext>
        </DndContext>
    );
};
export default ItemsSortableList;